import { selectSelectedFolder } from '.';
import { IApplicationState } from '../../types/redux';

export const selectFolderOffersCount = (state: IApplicationState) => {
  const selectedFolder = selectSelectedFolder(state);

  return selectedFolder?.offersCount ?? 0;
};
